/* ----------------------------------------------------------- */

  import {
    apiToInstall as defaultApiRoutes,
  } from '../../features/api'

  import {
    routes as homeAppRoutes,
    routeToInstall as homeRoute,
    storeToInstall as homeStore,
  } from '../../features/home'

  import {
    routes as chaptersAppRoutes,
    routeToInstall as chaptersRoute,
    storeToInstall as chaptersStore,
  } from '../../features/chapters'

  import {
    routes as pagesAppRoutes,
    routeToInstall as pagesRoute,
    storeToInstall as pagesStore,
  } from '../../features/pages'

  import {
    storeToInstall as navigationStore,
  } from '../../features/navigation'

  import {
    storeToInstall as accountStore,
    apiToInstall as accountApiRoutes,
  } from '../../features/account'

  import {
    routes as quizAppRoutes,
    routeToInstall as quizRoute,
    storeToInstall as quizStore,
    modalToInstall as quizModals,
  } from '../../features/quiz'

/* ----------------------------------------------------------- */
/* Install Routes */

  // Routes paths
  export const routes = [
    homeRoute,
    quizRoute,
    chaptersRoute,
    pagesRoute,
  ]

  // Routes to
  export const appRoutes = {
    ...homeAppRoutes,
    ...chaptersAppRoutes,
    ...pagesAppRoutes,
    ...quizAppRoutes,
  }

/* ----------------------------------------------------------- */
/* Install Stores */

  export const stores = {
    ...accountStore,
    ...homeStore,
    ...chaptersStore,
    ...pagesStore,
    ...navigationStore,
    ...quizStore,
  }

/* ----------------------------------------------------------- */
/* Install Modals */

  export const modals = [
    ...quizModals,
  ]

/* ----------------------------------------------------------- */
/* Install Api Routes */

  export const apiRoutes = {
    // ...defaultApiRoutes,
    ...accountApiRoutes,
  }

/* ----------------------------------------------------------- */
